<template>
  <v-text-field v-model="value" :label="label" :loading="loading" readonly>
    <!-- begin ref buttons -->
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.selectBtn != null && refSpecs.selectBtn.placement != null
          ? refSpecs.selectBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn slot="activator" icon class="ma-0" @click="$emit('refShowList')">
        <v-icon>find_replace</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.selectBtn != null && refSpecs.selectBtn.description != null
            ? refSpecs.selectBtn.description
            : 'Select'
        }}
      </div>
    </v-tooltip>
    <v-tooltip
      v-if="refSpecs != null"
      :slot="
        refSpecs.clearBtn != null && refSpecs.clearBtn.placement != null
          ? refSpecs.clearBtn.placement
          : 'append'
      "
      color="white grey--text"
      left
    >
      <v-btn
        slot="activator"
        icon
        class="ma-0"
        @click="$emit('refClearSelection')"
      >
        <v-icon>clear</v-icon>
      </v-btn>
      <div class="vjsf-tooltip">
        {{
          refSpecs.clearBtn != null && refSpecs.clearBtn.description != null
            ? refSpecs.clearBtn.description
            : 'Clear'
        }}
      </div>
    </v-tooltip>
    <!-- end ref buttons -->
  </v-text-field>
</template>

<script>
import api from '../../APIService'

export default {
  props: {
    entityId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    },
    functionName: {
      type: String,
      required: true
    },
    functionArgs: {
      type: Array,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hide: {
      type: Object,
      default: null
    },
    show: {
      type: Object,
      default: null
    },
    makeReadonly: {
      type: Object,
      default: null
    },
    refSpecs: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      value: null,
      loading: false
    }
  },
  created() {
    this.refreshValue()
  },
  methods: {
    refreshValue() {
      this.loading = true
      api
        .getFunctionValue(
          this.entityId,
          this.entryId,
          this.functionName,
          this.functionArgs
        )
        .then((response) => {
          this.value = response.data.result
          this.loading = false
          // emit hide & show
          if (this.hide != null) {
            this.$emit('hide', this.hide, this.value)
          }
          if (this.show != null) {
            this.$emit('show', this.show, this.value)
          }
          if (this.makeReadonly != null) {
            this.$emit('make-readonly', this.makeReadonly, this.value)
            console.log('making readonly from function widget')
          }
        })
        .catch((ex) => {
          console.log('Could not get function value: ' + ex)
          this.value = null
          this.loading = false
        })
    }
  }
}
</script>
